import { render, staticRenderFns } from "./FilterPublicProductCategoriesChild.vue?vue&type=template&id=55f6e128&"
import script from "./FilterPublicProductCategoriesChild.vue?vue&type=script&lang=js&"
export * from "./FilterPublicProductCategoriesChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports